import { Col, Form, Row } from "react-bootstrap";
import { useState, useEffect } from "react";
import * as yup from "yup";
import "./editbox.css";
const Editdilogbox = ({
  setEditbox,
  editbox,
  inputChange,
  userDatahandler,
  userDatahandler1,
  userDatahandler2,
  userDatahandler3,
  userDatahandler4,
  createShop,
}) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    // Set initial value based on which edit box is open
    if (!editbox) return;
    const initial =
      editbox === 1
        ? createShop?.atext || ""
        : editbox === 2
        ? createShop?.btext || ""
        : editbox === 3
        ? createShop?.ctext || ""
        : editbox === 4
        ? createShop?.email || ""
        : editbox === 5
        ? createShop?.createdAt || ""
        : "";
    setValue(initial);
    setError("");
  }, [editbox, createShop]);

  const getSchemaForEditbox = (box) => {
    switch (box) {
      case 1:
        return yup.string().required("Address is required").min(3, "Enter a valid address");
      case 2:
        return yup.string().required("Education is required").min(2, "Enter a valid education");
      case 3:
        return yup
          .string()
          .required("Contact number is required")
          .min(7, "Enter a valid contact number");
      case 4:
        return yup.string().required("Email is required").email("Enter a valid email");
      case 5:
        return yup.string().required("Date is required");
      default:
        return yup.string();
    }
  };

  const handleSave = async () => {
    const schema = getSchemaForEditbox(editbox);
    try {
      const validated = await schema.validate(value);
      setError("");
      // Call appropriate handler with validated value
      if (editbox === 1) userDatahandler(validated);
      else if (editbox === 2) userDatahandler1(validated);
      else if (editbox === 3) userDatahandler2(validated);
      else if (editbox === 4) userDatahandler3(validated);
      else if (editbox === 5) userDatahandler4(validated);
    } catch (e) {
      setError(e?.message || "Invalid input");
    }
  };
  return (
    <>
      <Row>
        <Col xl="2" lg={3} sm={12} md={9} className="smallDialogBox">
          <div className="form-row Backgroundbox">
            <div className="col-md-12 ps-2 p-2 pt-0">
              <label htmlFor="validationTooltip03"></label>
              <input
                type="text"
                className={`form-control writeinput mt-0 ${error ? "is-invalid" : ""}`}
                id="validationTooltip03"
                placeholder="Write Something"
                name={
                  editbox === 1
                    ? "atext"
                    : editbox === 2
                    ? "btext"
                    : editbox === 3
                    ? "ctext"
                    : editbox === 4
                    ? "email"
                    : editbox === 5
                    ? "createdAt"
                    : ""
                }
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  setError("");
                  inputChange(e);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSave();
                  }
                }}
              />
              {error && <div className="invalid-feedback">{error}</div>}
            </div>
            <div className="col-12 pb-3 ps-2">
              <div className="modal-body boxes ">
                <div className="pt-0">
                  <button
                    type="button"
                    className="btn  text-white font_small bg-dark pt-0 pb-0"
                    onClick={() => setEditbox(false)}
                  >
                    Cancel
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    className="btn btn-primary text-white font_small bg-blue  pt-0 pb-0 "
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default Editdilogbox;
